import { inject, provideAppInitializer } from '@angular/core';
import { CacheKey } from 'app/helpers/app-constants';
import { getAuth, signInWithCustomToken } from 'firebase/auth';
import { AuthService } from '../auth/auth.service';

export const provideAuthInitializer = () =>
    provideAppInitializer(async () => {
        const authService = inject(AuthService);

        const tokenToUse = authService.clientSwitchAccessToken;
      
        if (tokenToUse) {
            // 💥 Burn on read: clear it instantly so it cannot loop or replay
            localStorage.removeItem(CacheKey.clientSwitchAccessToken);

            try {
                const auth = getAuth();

                // 1. FORCE Angular to wait for the custom token handshake to finish
                const credential = await signInWithCustomToken(auth, tokenToUse);

                // 2. FORCE Angular to wait for Google to sign and return a fresh ID Token string
                const freshIdToken = await credential.user.getIdToken(true);
                const freshRefreshToken = credential.user.refreshToken;

                // 3. Update your AuthService memory IMMEDIATELY while the app is still frozen
                authService.updateTokens({
                    accessToken: freshIdToken,
                    refreshToken: freshRefreshToken,
                });
              
            } catch (error) {
                console.error('❌ Modern App Initializer: Firebase custom token swap failed:', error);
            }
        }
    });
